import ComponentPlaceholder from 'components/ComponentPlaceholder';
import DiscountBubble from 'components/DiscountBubble';
import Img from 'components/Img';
import { LayoutContainer } from 'components/Layout';
import type { DigizuiteAsset } from 'models/asset';
import type { Field, SitecoreBlockProps } from 'models/sitecore';
import { getEditorMargin } from 'utils/business-logic';
import { getAsset } from 'utils/helpers';

interface Props extends SitecoreBlockProps {
	fields?: {
		campaignBubbleLabel?: Field<string>;
		campaignBubbleSale?: Field<boolean>;
		campaignBubbleText?: Field<string>;
		landscapeImage: Field<DigizuiteAsset[]>;
		wideImage: Field<DigizuiteAsset[]>;
	};
}

export default function MediaBanner({ fields, params }: Props) {
	if (!fields) {
		return null;
	}

	const largeImg = getAsset('Templated 4:1', fields.wideImage);
	const smallImg = getAsset('Templated 2:1', fields.landscapeImage);
	const campaignBubbleLabel = fields.campaignBubbleLabel?.value;
	const campaignBubbleSale = Boolean(fields.campaignBubbleSale?.value);
	const campaignBubbleText = fields.campaignBubbleText?.value;

	if (!largeImg || !smallImg) {
		return (
			<ComponentPlaceholder
				componentName="MediaBanner"
				className={getEditorMargin(params)}
				description="Requires a wide and a landscape image"
			/>
		);
	}

	return (
		<LayoutContainer
			id={params?.anchor}
			gutters="sm"
			outerClassName={getEditorMargin(params)}
			innerClassName="relative"
		>
			<Img
				src={smallImg?.src}
				alt={smallImg?.alt}
				width={360}
				height={180}
				className="w-full sm:hidden"
			/>
			<Img
				src={largeImg?.src}
				alt={largeImg?.alt}
				width={1644}
				height={411}
				className="w-full max-sm:hidden"
			/>
			{campaignBubbleText && (
				<>
					<DiscountBubble
						label={campaignBubbleLabel}
						text={campaignBubbleText}
						isSale={campaignBubbleSale}
						isPositioned
						size="small"
						className="lg:hidden"
					/>
					<DiscountBubble
						label={campaignBubbleLabel}
						text={campaignBubbleText}
						isSale={campaignBubbleSale}
						isPositioned
						size="xLarge"
						className="max-lg:hidden"
					/>
				</>
			)}
		</LayoutContainer>
	);
}
MediaBanner.displayName = 'MediaBanner';
